/* MANAGE ACCEPTED CLOSURES */
Vue.component('acceptedclosures',{
    template:'#acceptedclosures-template',
    data:function(){
        return{
            searchString:'',
            moment: moment,
            projects:[]
        };
    },
    created:function(){

        activeInstance = this;

        var id = $('#content_wrapper').attr('data-id');
        activeInstance.getAcceptedClosures();

        setTimeout(function(){
            var $table = $('.fixed_header_table');
            $table.floatThead({
                top:70
            });
        },200);
    },
    methods:{
        toggleProjectDetails:function(project){

            $.each(activeInstance.projects,function(index,project_record){
                project_record.details_status = 'open';
            });

            return;
        },
        confirm:function(record){
            bootbox.confirm('Biztosan jóváhagyod a ' + record.name +' zárását?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    axios.post(baseURL+'/api/ticket/subscribe/update', {
                        ticket_id: activeInstance.ticket.id,
                        subscribed: !activeInstance.user_is_subscribed
                    })
                    .then(function (response) {
                        activeInstance.user_is_subscribed = response.data.subscribed;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        reject:function(record){
            bootbox.confirm('Biztosan elutasítod a ' + record.name +' zárását?', function(value){
                if(value==true){

                    showLoadingOverlay();
                    axios.post(baseURL+'/api/ticket/subscribe/update', {
                        ticket_id: activeInstance.ticket.id,
                        subscribed: !activeInstance.user_is_subscribed
                    })
                    .then(function (response) {
                        activeInstance.user_is_subscribed = response.data.subscribed;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        getAcceptedClosures:function(){
            showLoadingOverlay();
            axios.get(baseURL+'/api/ticket/accepted_closures').then(function(response) {


                $.each(response.data,function(index,project){
                    project.details_status = 'open';
                });

                $('body').LoadingOverlay("hide");

                activeInstance.projects = response.data;
            }).catch(function(error) {
                $('body').LoadingOverlay("hide");
                console.log(error);
            });
        },
        openProject:function(record){
            bootbox.confirm('Biztosan megnyitod a ' + record.name +' projektet?', function(value){
                if(value==true){

                    $('body').LoadingOverlay("show");
                    axios.post(baseURL+'/admin/project/open', {
                        project_id: record.id
                    })
                    .then(function (response) {
                        $('body').LoadingOverlay("hide");
                        record.phase = 'active';
                    })
                    .catch(function (error) {
                        $('body').LoadingOverlay("hide");
                        console.log(error);
                    });
                }
            });
        },
        openTicket:function(record){
            bootbox.confirm('Biztosan megnyitod a ' + record.name +' ticketet?', function(value){
                if(value==true){

                    $('body').LoadingOverlay("show");
                    axios.post(baseURL+'/admin/project/ticket/open', {
                        ticket_id: record.id
                    })
                    .then(function (response) {
                        $('body').LoadingOverlay("hide");

                        /*
                        $.each(activeInstance.projects,function(index,project){
                            if (record.project_id == project.id) {
                                $.each(project.tickets,function(index,ticket){
                                    if (record.id == ticket.id) {
                                        ticket.phase = 'completed';
                                    }
                                });
                            }
                        });
                        */
                        record.phase = 'active';

                        activeInstance.getAcceptedClosures();
                    })
                    .catch(function (error) {
                        $('body').LoadingOverlay("hide");
                        console.log(error);
                    });
                }
            });
        },
    }
});